let prefix = '/api/failureType';

function getFailureType() {
    return window.axios.get(prefix);
}
function indexForDelayEvent() {
    return window.axios.get(prefix + '/indexForDelayEvent');
}
function storeFailureType(data) {
    return window.axios.post(prefix, data);
}
function updateFailureType(data) {
    return window.axios.put(prefix+'/'+data.id, data.data);
}
function changeActiveStatus(id) {
    return window.axios.patch(prefix+'/'+id);
}

export default {
    getFailureType, indexForDelayEvent, storeFailureType, updateFailureType, changeActiveStatus
  
}